module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-cyrillic-ext26.7ab4304.woff2";